import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },

  content: {
    flex: 1,
  },

  typeSelect: {
    marginTop: theme.spacing(3),
    flex: 1,
  },

  summary: {
    flex: 1,
    justifyContent: 'flex-end',
    marginTop: theme.spacing(4),
  },

  receiveValue: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    textAlign: 'right',
  },
}));
